import { render, staticRenderFns } from "./bookReviewListPage.vue?vue&type=template&id=be5ad5bc&"
import script from "./bookReviewListPage.vue?vue&type=script&lang=js&"
export * from "./bookReviewListPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports